import { useState, useCallback } from 'react';
import './Homepage.css';
import Heropage from '../Heropage/Heropage';
import Navbar from '../../components/Navbar/Navbar';

const Homepage = ({ handleLogin }) => {
  return (
    <div className="Home">
      <Navbar handleLogin={handleLogin} />
      
      {/* Main Content */}
      <main className="main-content">
        <Heropage />
      </main>
    </div>
  );
};

export default Homepage;
